import React, { useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getInputData } from '../../store/forms';
import { addError } from '../../store/errors';
import { sendCheckin2Data } from '../../api/endpoints';
import { handleFormApiCall } from '../../api/index';
import Camera from '../../components/Camera';
import useCheckin2Validation from '../../hooks/validations/useCheckin2Validation';
import CheckInStep2View from './View'; // El componente de UI
import { componerConfiguracion } from '../../store/selectors';

function CheckInStep2() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    // Lógica de estado y hooks
    const [loading, setLoading] = useState(false);
    const [buttonPressed, setButtonPressed] = useState(false);
    const [warranty, setWarranty] = useState(false);
    const [error, setError] = useState('');
    const ref = useRef(null);
        
    const selectViewConfig = useMemo(componerConfiguracion, []);
    const viewParameters = useSelector(state => selectViewConfig(state, 'CheckInStep2'));

    const view = "checkin2";
	const filesForm = "files";
	const cedulaAdelante = useSelector(getInputData(view, filesForm, "cedulaAdelante"));
	const cedulaPosterior = useSelector(getInputData(view, filesForm, "cedulaPosterior"));
	const licenciaAdelante = useSelector(getInputData(view, filesForm, "licenciaAdelante"));
	const licenciaPosterior = useSelector(getInputData(view, filesForm, "licenciaPosterior"));
	const birthday = useSelector(getInputData(view, filesForm, "birthday"));
	const driveLicenseExpiration = useSelector(getInputData(view, filesForm, "driveLicenseExpiration"));
	const identityCardExpiration = useSelector(getInputData(view, filesForm, "identityCardExpiration"));

	const warrantyForm = "warranty";
	const titularTarjeta = useSelector(getInputData(view, warrantyForm, "titularTarjeta"));
	const numeroTarjeta = useSelector(getInputData(view, warrantyForm, "numeroTarjeta"));
	const mesVencimiento = useSelector(getInputData(view, warrantyForm, "mesVencimiento"));
	const anoVencimiento = useSelector(getInputData(view, warrantyForm, "anoVencimiento"));
	
  	const handleError = (err) => {
	    dispatch(addError(err));
	  };
	const handleSuccessCheckin2 = (input) => {
		console.log('handleSuccessCheckin2', input);
    	const success = input.data.data[0].cod_sal === "0000";
    	if (success){
	    	navigate('/finish');
	    }else{
	    	setError(`Ha habido un problema con el servicio ${sendCheckin2Data}`);
	    	setTimeout(() => setError(''), 7000);
	    	handleError(input);
	    }
	    setLoading(false);
  	};
  
    const reservationNumber = useSelector(getInputData("login", "checkinLogin", "reservationNumber"));
    const { validConsent, validFiles } = useCheckin2Validation(true);
    const handleCheckin2 = (e) => {
        e.preventDefault();
        setButtonPressed(true);
        if (validFiles && validConsent) {
            setError('');
            const formData = new FormData();
            if(cedulaAdelante.source === 'user') formData.append("cedulaAdelante", cedulaAdelante.data);
            if(cedulaPosterior.source === 'user') formData.append("cedulaPosterior", cedulaPosterior.data);
            if(licenciaAdelante.source === 'user') formData.append("licenciaAdelante", licenciaAdelante.data);
            if(licenciaPosterior.source === 'user') formData.append("licenciaPosterior", licenciaPosterior.data);
            handleFormApiCall(sendCheckin2Data, formData, [
                reservationNumber.data,
                birthday.data.format('YYYY-MM-DD'),
                identityCardExpiration.data.format('YYYY-MM-DD'),
                driveLicenseExpiration.data.format('YYYY-MM-DD'),
                titularTarjeta.data,
                numeroTarjeta.data,
                mesVencimiento.data === '' ? '0' : mesVencimiento.data,
                anoVencimiento.data === '' ? '0' : anoVencimiento.data,
            ], handleSuccessCheckin2, handleError);
            setLoading(true);
        }else if (!validFiles) {
            setError('Complete toda la información');
            setTimeout(() => setError(''), 7000);
        }else{
            setError('Entregue su consentimiento para envíar la información.');
            setTimeout(() => setError(''), 7000);
        }
        
    };

    // Pasa todo a la vista: configuración, estado y manejadores de eventos.
    return (
        <Camera> 
            <CheckInStep2View
                templateRef={ref}
                viewParameters={viewParameters}
                warranty={warranty}
                loading={loading}
                error={error}
                buttonPressed={buttonPressed}
                onSetWarranty={setWarranty}
                onSubmit={handleCheckin2}
            />
        </Camera>
    );
}

export default CheckInStep2;